/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

import { EventEmitter } from 'events'
import {
  WebSocketMessageSubscriber,
  ReceiveMessageBody,
  WebSocketMessageTypes,
  WebSocketReceiverInterface
} from '@/websocket/types'
import { WebSocketMessageMode } from '@/websocket/constants'

export default class WebSocketReceiver<T extends WebSocketMessageMode>
  implements WebSocketReceiverInterface<T> {
  events = new EventEmitter()

  handleMessage(messageBody: ReceiveMessageBody<T, WebSocketMessageTypes<T>>) {}

  subscribe<K extends WebSocketMessageTypes<T>>(
    messageType: K,
    subscriber: WebSocketMessageSubscriber<T, K>
  ) {
    this.events.on(messageType, subscriber)

    return () => this.events.off(messageType, subscriber)
  }
}
